(function(){
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') {
      var forms = document.querySelectorAll('.contact-form__form');
      forms.forEach(function(form) {
        var out = form.querySelector('.form__success-message');
        if (out) {
          var defaultMsg = out.getAttribute('data-default-message');
          if (defaultMsg) {
            out.innerHTML = defaultMsg;
          }
        }
      });
    }
  } catch (e) {
    /* ignore */
  }
})();